import { render, staticRenderFns } from "./ObservationList.vue?vue&type=template&id=262bda98&scoped=true&"
import script from "./ObservationList.js?vue&type=script&lang=js&"
export * from "./ObservationList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262bda98",
  null
  
)

export default component.exports